import { capitalizeWord } from '../capitalize';

export default (str: string) =>
  str
    .split(' ')
    .map((word, i) => (i === 0 ? word.toLowerCase() : capitalizeWord(word)))
    .join('');
